module.exports = __webpack_public_path__ + "img/icon (3).65a430e5.png";